import { FC } from 'react';
import ContentLoader from 'react-content-loader';
import { useTheme } from 'styled-components/macro';

const RooftopsLoader: FC = () => {
  const theme = useTheme();

  return (
    <ContentLoader
      speed={2}
      width="100%"
      height="100%"
      backgroundColor={theme.colors.primary.variant1}
      foregroundColor={theme.colors.rgba.variant2}
      data-testid="rooftop-loader"
    >
      <rect x="276" y="10" rx="10" ry="10" width="40" height="24" />
      <rect x="16" y="17" rx="3" ry="3" width="178" height="16" />
      <rect x="220" y="10" rx="10" ry="10" width="40" height="24" />
      <rect x="276" y="63" rx="10" ry="10" width="40" height="24" />
      <rect x="220" y="63" rx="10" ry="10" width="40" height="24" />
      <rect x="16" y="66" rx="3" ry="3" width="178" height="16" />
    </ContentLoader>
  );
};

export default RooftopsLoader;
